import {
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import React, { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import Home from "../../home/Home";
import { getDate } from "../../Utils/Common";
import { useEffect } from "react";
import DSR_Services from "../../../Services/Reports/DSR_Services";
import Snackbar from "../../Snacbar";
import HashLoader from "react-spinners/HashLoader";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "rgb(61, 195, 177)",
    color: "black",
    textAlign: "center",
    fontFamily: "Times New Roman",
    fontWeight: "bold",
  },
  [`&.${tableCellClasses.body}`]: {
    textAlign: "center",
    fontSize: 14,
    fontFamily: "Times New Roman",
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));
const ItemPap = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  border: " 1px solid black",
  // backgroundColor: "#C8EDE7",
  height: "100%",
}));
const ItemPap1 = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  border: " 1px solid black",
  backgroundColor: "white",
}));

function DSR() {
  const mystyle = {
    border: " 1px solid black",
    width: "9rem",
    fontFamily: "Times New Roman",
  };
  const mystyle1 = {
    fontWeight: "bolder",
    color: "#0b64c5",
    fontFamily: "Times New Roman",
  };

  ///
  const [message, setMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [severit, setseverit] = useState("");
  const [showProcs, setshowProcs] = useState(false);
  const [reportProcs, setreportProcs] = useState(false);
  const [clearProcs, setclearProcs] = useState(false);
  const [details1, setdetails1] = useState([]);
  const [details2, setdetails2] = useState([]);
  const [details3, setdetails3] = useState([]);
  const [FilteredDetails, setFilteredDetails] = useState([]);
  const [loading, setloading] = useState(false);

  const [dsr3Values, setdsr3Values] = useState({
    from: getDate(),
    to: getDate(),
    branch: "-1",
    customer: "-1",
    operation: "-1",
  });
  const fromhandlechange = (e) => {
    setdsr3Values({ ...dsr3Values, from: e.target.value });
  };
  const tohandlechange = (e) => {
    setdsr3Values({ ...dsr3Values, to: e.target.value });
  };
  const branchhandlechange = (e) => {
    setdsr3Values({
      ...dsr3Values,
      branch: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, ""),
    });
  };
  const customerhandlechange = (e) => {
    setdsr3Values({
      ...dsr3Values,
      customer: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, ""),
    });
  };
  const operationhandlechange = (e) => {
    setdsr3Values({
      ...dsr3Values,
      operation: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, ""),
    });
  };
  //error message
  const handleClose = () => {
    setOpen(false);
  };
  ///getfunctions
  const getfunctions = () => {
    DSR_Services.selectBranchDetails().then((res) => {
      setdetails1(res.data);
    });
    DSR_Services.getCustomerBasedCustomerType("Importer").then((res) => {
      setdetails2(res.data);
    });
  };
  // btnOperations===>
  const showBtnClick = () => {
    setshowProcs(true);
    setloading(true);
    setPage(0);
    var importer_iec_no,
      regionalId,
      operationType = "";
    if (dsr3Values.customer === "ALL") {
      importer_iec_no = "-1";
    } else {
      importer_iec_no = dsr3Values.customer;
    }
    if (dsr3Values.branch === "ALL") {
      regionalId = -1;
    } else {
      regionalId = dsr3Values.branch;
    }
    if (dsr3Values.operation === "ALL") {
      operationType = "-1";
    } else {
      operationType = dsr3Values.operation;
    }
    let details = {
      fromDate: dsr3Values.from,
      toDate: dsr3Values.to,
      importer_iec_no: importer_iec_no,
      regionalId: regionalId,
      operationType: operationType,
      transitTypeId: "-1",
      customId: -1,
      clearanceStatus: "-1",
      employeeId: -1,
    };
    DSR_Services.getDSR_ReportNew(details).then((res) => {
      const data = res.data;
      const details = data.map((item) => item);
      if (details[0] === [] || !details[0]) {
        setMessage("No Record Found");
        setseverit("warning");
        setOpen(true);
        setshowProcs(false);
        setloading(false);
      } else {
        setdetails3(res.data);
        setFilteredDetails(res.data);
        setshowProcs(false);
        setloading(false);
      }
    });
  };

  const reportBtnClick = () => {
    if (!FilteredDetails || FilteredDetails.length === 0) {
      setMessage("No Record Found");
      setseverit("warning");
      setOpen(true);
      return;
    }

    try {
      // ✅ Get from/to date from state
      const fromDate = dsr3Values.from || "N/A";
      const toDate = dsr3Values.to || "N/A";

      // ✅ Define headers (matching your table columns)
      const headers = [
        { header: "Sl No", key: "slno" },
        { header: "Job No", key: "job_no" },
        { header: "Job Date", key: "job_date" },
        { header: "Location", key: "location" },
        { header: "Mode", key: "mode" },
        { header: "Customer", key: "customrs" },
        { header: "HAWB No", key: "hawb_no" },
        { header: "MAWB No", key: "mawbNo" },
        { header: "BOE No", key: "boe_no" },
        { header: "BOE Date", key: "boe_date" },
        { header: "Invoice Value", key: "invValue" },
        { header: "Port Description", key: "prt_disc" },
        { header: "BOE Assessment Date", key: "boe_ass_date" },
        { header: "Release Date", key: "rls_date" },
        { header: "Freight Rs Bill", key: "fl_rs_bill" },
        { header: "Requested Exp", key: "req_exp" },
        { header: "Approved Exp", key: "apred_exp" },
        { header: "Invoice No", key: "inv_no" },
        { header: "Invoice Date", key: "inv_date" },
        { header: "Tax Amount", key: "tax_amt" },
        { header: "Non-Tax Amount", key: "non_tax_amt" },
        { header: "Remarks", key: "remarks" },
        { header: "Invoice Dispatch Date", key: "inv_disc_date" },
        { header: "MO Dispatch", key: "m_o_disc" },
      ];

      // ✅ Prepare data rows
      const dataWithHeaders = FilteredDetails.map((row, index) => {
        const newRow = {};
        headers.forEach((h) => {
          if (h.key === "slno") newRow[h.header] = index + 1;
          else newRow[h.header] = row[h.key] ?? "";
        });
        return newRow;
      });

      // ✅ Combine title and date rows before the table
      const title = [["DSR REPORT"]];
      const dateRange = [[`From: ${fromDate}`, `To: ${toDate}`]];
      const emptyRow = [[]]; // blank line
      const tableHeaders = [headers.map((h) => h.header)];
      const tableData = dataWithHeaders.map((row) => Object.values(row));

      const finalData = [
        ...title,
        ...dateRange,
        ...emptyRow,
        ...tableHeaders,
        ...tableData,
      ];

      // ✅ Create worksheet and workbook
      const worksheet = XLSX.utils.aoa_to_sheet(finalData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "DSR Report");

      // ✅ Merge title row (A1 across all columns)
      const totalCols = headers.length;
      worksheet["!merges"] = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: totalCols - 1 } }, // merge A1..X1
      ];

      // ✅ Adjust column widths
      worksheet["!cols"] = headers.map(() => ({ wch: 18 }));

      // ✅ Export file
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const fileName = `DSR_Report_${fromDate}_to_${toDate}.xlsx`;
      saveAs(blob, fileName);

      setMessage("Report generated successfully!");
      setseverit("success");
      setOpen(true);
    } catch (error) {
      console.error("Error generating report:", error);
      setMessage("Error generating report");
      setseverit("error");
      setOpen(true);
    }
  };

  const clrBtnClick = () => {
    setclearProcs(true);
    setshowProcs(false);
    setdsr3Values({
      ...dsr3Values,
      from: getDate(),
      to: getDate(),
      branch: "-1",
      customer: "-1",
      operation: "-1",
    });
    setdetails3([]);
    setFilteredDetails([]);
    setreportProcs(false);
    setclearProcs(false);
  };
  useEffect(() => {
    setloading(true);
    setTimeout(() => {
      setloading(false);
    }, 1000);
    getfunctions();
  }, []);

  //tableSearch
  const branchNmSrch = () => {
    return (
      <input
        style={{ width: "80px", textAlign: "center", fontSize: "12px" }}
        placeholder="Search"
        onChange={(e) => {
          branchNmOnchange(e.target.value);
        }}
      />
    );
  };
  const opertionTypeSrch = () => {
    return (
      <input
        style={{ width: "80px", textAlign: "center", fontSize: "12px" }}
        placeholder="Search"
        onChange={(e) => {
          opertionTypeOnchange(e.target.value);
        }}
      />
    );
  };
  const jobNoSrch = () => {
    return (
      <input
        style={{ width: "80px", textAlign: "center", fontSize: "12px" }}
        placeholder="Search"
        onChange={(e) => {
          jobNoOnchange(e.target.value);
        }}
      />
    );
  };
  const impNmSrch = () => {
    return (
      <input
        style={{ width: "80px", textAlign: "center", fontSize: "12px" }}
        placeholder="Search"
        onChange={(e) => {
          impNmOnchange(e.target.value);
        }}
      />
    );
  };
  const impcitySrch = () => {
    return (
      <input
        style={{ width: "80px", textAlign: "center", fontSize: "12px" }}
        placeholder="Search"
        onChange={(e) => {
          impcityOnchange(e.target.value);
        }}
      />
    );
  };
  const PortCdSrch = () => {
    return (
      <input
        style={{ width: "80px", textAlign: "center", fontSize: "12px" }}
        placeholder="Search"
        onChange={(e) => {
          PortCdOnchange(e.target.value);
        }}
      />
    );
  };
  const cntryOrginSrch = () => {
    return (
      <input
        style={{ width: "80px", textAlign: "center", fontSize: "12px" }}
        placeholder="Search"
        onChange={(e) => {
          cntryOrginOnchange(e.target.value);
        }}
      />
    );
  };
  const portOriginSrch = () => {
    return (
      <input
        style={{ width: "80px", textAlign: "center", fontSize: "12px" }}
        placeholder="Search"
        onChange={(e) => {
          portOriginOnchange(e.target.value);
        }}
      />
    );
  };
  const modeofTrnsportSrch = () => {
    return (
      <input
        style={{ width: "80px", textAlign: "center", fontSize: "12px" }}
        placeholder="Search"
        onChange={(e) => {
          modeofTrnsportOnchange(e.target.value);
        }}
      />
    );
  };
  const reportingPortSrch = () => {
    return (
      <input
        style={{ width: "80px", textAlign: "center", fontSize: "12px" }}
        placeholder="Search"
        onChange={(e) => {
          reportingPortOnchange(e.target.value);
        }}
      />
    );
  };
  const invoiceNoSrch = () => {
    return (
      <input
        style={{ width: "80px", textAlign: "center", fontSize: "12px" }}
        placeholder="Search"
        onChange={(e) => {
          invoiceNoOnchange(e.target.value);
        }}
      />
    );
  };
  const SupplierNmSrch = () => {
    return (
      <input
        style={{ width: "80px", textAlign: "center", fontSize: "12px" }}
        placeholder="Search"
        onChange={(e) => {
          SupplierNmOnchange(e.target.value);
        }}
      />
    );
  };
  const SuppliercntrySrch = () => {
    return (
      <input
        style={{ width: "80px", textAlign: "center", fontSize: "12px" }}
        placeholder="Search"
        onChange={(e) => {
          SuppliercntryOnchange(e.target.value);
        }}
      />
    );
  };
  const itemDesc1Srch = () => {
    return (
      <input
        style={{ width: "80px", textAlign: "center", fontSize: "12px" }}
        placeholder="Search"
        onChange={(e) => {
          itemDesc1Onchange(e.target.value);
        }}
      />
    );
  };
  //
  const branchNmOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.regionalName
        .toString()
        .toLowerCase()
        .includes(searchedVal.toLowerCase());
    });
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3);
    } else {
      setFilteredDetails(filteredvalue);
    }
  };
  const opertionTypeOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.operationType
        .toString()
        .toLowerCase()
        .includes(searchedVal.toLowerCase());
    });
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3);
    } else {
      setFilteredDetails(filteredvalue);
    }
  };
  const jobNoOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.consignmentNumber
        .toString()
        .toLowerCase()
        .includes(searchedVal.toLowerCase());
    });
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3);
    } else {
      setFilteredDetails(filteredvalue);
    }
  };
  const impNmOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.importer_name
        .toString()
        .toLowerCase()
        .includes(searchedVal.toLowerCase());
    });
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3);
    } else {
      setFilteredDetails(filteredvalue);
    }
  };
  const impcityOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.importerCity
        .toString()
        .toLowerCase()
        .includes(searchedVal.toLowerCase());
    });
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3);
    } else {
      setFilteredDetails(filteredvalue);
    }
  };
  const PortCdOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.cusHouseCode
        .toString()
        .toLowerCase()
        .includes(searchedVal.toLowerCase());
    });
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3);
    } else {
      setFilteredDetails(filteredvalue);
    }
  };
  const cntryOrginOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.countryOfOrigin
        .toString()
        .toLowerCase()
        .includes(searchedVal.toLowerCase());
    });
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3);
    } else {
      setFilteredDetails(filteredvalue);
    }
  };
  const portOriginOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.origin_portName
        .toString()
        .toLowerCase()
        .includes(searchedVal.toLowerCase());
    });
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3);
    } else {
      setFilteredDetails(filteredvalue);
    }
  };
  const modeofTrnsportOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.transitTypeCode
        .toString()
        .toLowerCase()
        .includes(searchedVal.toLowerCase());
    });
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3);
    } else {
      setFilteredDetails(filteredvalue);
    }
  };
  const reportingPortOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.gateWay_port_code
        .toString()
        .toLowerCase()
        .includes(searchedVal.toLowerCase());
    });
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3);
    } else {
      setFilteredDetails(filteredvalue);
    }
  };
  const invoiceNoOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.invoiceNumber
        .toString()
        .toLowerCase()
        .includes(searchedVal.toLowerCase());
    });
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3);
    } else {
      setFilteredDetails(filteredvalue);
    }
  };
  const SupplierNmOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.supName
        .toString()
        .toLowerCase()
        .includes(searchedVal.toLowerCase());
    });
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3);
    } else {
      setFilteredDetails(filteredvalue);
    }
  };
  const SuppliercntryOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.supCountry
        .toString()
        .toLowerCase()
        .includes(searchedVal.toLowerCase());
    });
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3);
    } else {
      setFilteredDetails(filteredvalue);
    }
  };
  const itemDesc1Onchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.item_description
        .toString()
        .toLowerCase()
        .includes(searchedVal.toLowerCase());
    });
    if (filteredvalue.length < 1) {
      setFilteredDetails(details3);
    } else {
      setFilteredDetails(filteredvalue);
    }
  };
  //paginationCodes

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  return (
    <div>
      <Home />
      <div style={{ paddingLeft: "80px" }}>
        <Snackbar
          open={open}
          message={message}
          severity={severit}
          onClose={handleClose}
        />
        {loading ? (
          <div className="loaderCss">
            <HashLoader
              color={"#296cbc"}
              loading={loading}
              size={50}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>
        ) : (
          <ItemPap>
            <Row>
              <div
                className="Billingtitleclr"
                style={{
                  color: "red",
                  fontWeight: "bold",
                  fontSize: "25px",
                  marginTop: "1%",
                  marginBottom: "1%",
                }}
              >
                <center>DSR REPORT</center>
              </div>
              <Col></Col>
              <Col>
                <center>
                  <label style={mystyle1}>From Date</label>
                  <Form.Control
                    size="sm"
                    type="date"
                    style={mystyle}
                    value={dsr3Values.from}
                    onChange={fromhandlechange}
                  />
                </center>
              </Col>
              <Col>
                <center>
                  <label style={mystyle1}>To Date</label>
                  <Form.Control
                    size="sm"
                    type="date"
                    style={mystyle}
                    value={dsr3Values.to}
                    onChange={tohandlechange}
                  />
                </center>
              </Col>
              <Col>
                <center>
                  <label style={mystyle1}>Branch</label>
                  <Form.Select
                    size="sm"
                    style={mystyle}
                    value={dsr3Values.branch}
                    onChange={branchhandlechange}
                  >
                    {details1.map((trns) => (
                      <option value={trns.regionId}>{trns.regionalName}</option>
                    ))}
                  </Form.Select>
                </center>
              </Col>
              <Col>
                <center>
                  <label style={mystyle1}>Customer</label>
                  <Form.Select
                    type="text"
                    list="code"
                    style={mystyle}
                    size="sm"
                    value={dsr3Values.customer}
                    onChange={customerhandlechange}
                  >
                    <option value={"-1"}>ALL</option>
                    {details2.map((trns) => (
                      <option value={trns.importer_iec_no}>
                        {trns.importer_name}
                      </option>
                    ))}
                  </Form.Select>
                </center>
              </Col>
              <Col>
                <center>
                  <label style={mystyle1}>Operation</label>
                  <Form.Select
                    size="sm"
                    style={mystyle}
                    value={dsr3Values.operation}
                    onChange={operationhandlechange}
                  >
                    <option value={"-1"}>ALL</option>
                    <option value={"IMPORT"}>IMPORT</option>
                    <option value={"EXPORT"}>EXPORT</option>
                    <option value={"COURIER"}>COURIER</option>
                  </Form.Select>
                </center>
              </Col>
              <Col></Col>
            </Row>
            <Row className="mb-1 mt-2">
              <Col lg={4}></Col>
              <Col lg={4}>
                <Button
                  variant="primary"
                  style={{ fontFamily: "Times New Roman" }}
                  size="sm"
                  onClick={showBtnClick}
                >
                  {" "}
                  {showProcs ? "processing..." : "Show"}{" "}
                </Button>
                &nbsp;
                <Button
                  variant="success"
                  style={{ fontFamily: "Times New Roman" }}
                  size="sm"
                  onClick={reportBtnClick}
                >
                  {reportProcs ? "processing..." : "Report"}
                </Button>
                &nbsp;
                <Button
                  variant="danger"
                  style={{ fontFamily: "Times New Roman" }}
                  size="sm"
                  onClick={clrBtnClick}
                >
                  {" "}
                  {clearProcs ? "processing..." : "Reset"}{" "}
                </Button>
              </Col>
              <Col lg={4}></Col>
            </Row>
            <ItemPap1>
              <TableContainer sx={{ height: 410 }} className="mt-1">
                <Table stickyHeader className="table table-bordered">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell>Sl No</StyledTableCell>
                      <StyledTableCell>Job No</StyledTableCell>
                      <StyledTableCell>Job Date</StyledTableCell>
                      <StyledTableCell>Location</StyledTableCell>
                      <StyledTableCell>Mode</StyledTableCell>
                      <StyledTableCell>Customer</StyledTableCell>
                      <StyledTableCell>HAWB No</StyledTableCell>
                      <StyledTableCell>MAWB No</StyledTableCell>
                      <StyledTableCell>BOE No</StyledTableCell>
                      <StyledTableCell>BOE Date</StyledTableCell>
                      <StyledTableCell>Invoice Value</StyledTableCell>
                      <StyledTableCell>Port Description</StyledTableCell>
                      <StyledTableCell>BOE Assessment Date</StyledTableCell>
                      <StyledTableCell>Release Date</StyledTableCell>
                      <StyledTableCell>Freight Rs Bill</StyledTableCell>
                      <StyledTableCell>Requested Exp</StyledTableCell>
                      <StyledTableCell>Approved Exp</StyledTableCell>
                      <StyledTableCell>Invoice No</StyledTableCell>
                      <StyledTableCell>Invoice Date</StyledTableCell>
                      <StyledTableCell>Tax Amount</StyledTableCell>
                      <StyledTableCell>Non-Tax Amount</StyledTableCell>
                      <StyledTableCell>Remarks</StyledTableCell>
                      <StyledTableCell>Invoice Dispatch Date</StyledTableCell>
                      <StyledTableCell>MO Dispatch</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>

                  <TableBody>
                    {FilteredDetails.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    ).map((row, index) => (
                      <TableRow hover key={index}>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {index + 1}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {row.job_no}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {row.job_date}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {row.location}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {row.mode}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {row.customrs}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {row.hawb_no}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {row.mawbNo}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {row.boe_no}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {row.boe_date}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {row.invValue}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {row.prt_disc}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {row.boe_ass_date}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {row.rls_date}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {row.fl_rs_bill}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {row.req_exp}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {row.apred_exp}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {row.inv_no}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {row.inv_date}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {row.tax_amt}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {row.non_tax_amt}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {row.remarks}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {row.inv_disc_date}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {row.m_o_disc}
                        </StyledTableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>

                <TablePagination
                  showFirstButton
                  showLastButton
                  component="div"
                  count={FilteredDetails.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onChangeRowsPerPage={handleChangeRowsPerPage}
                />
              </TableContainer>
            </ItemPap1>
          </ItemPap>
        )}
      </div>
    </div>
  );
}

export default DSR;
